const nonAscii = {
    a: "[àáâãäå]",
    e: "[èéêë]",
    i: "[ìíîï]",
    o: "[òóôõö]",
    u: "[ùúûűü]",
    n: "ñ",
};

export const splitButtonText = (string, index, separator = ";") => {
    return string?.split(separator)[index];
};

export const validPathname = (str) => {
    for (const i in nonAscii) {
        str = str.replace(new RegExp(nonAscii[i], "g"), i);
    }
    return str.replace(/\s/g, "-").toLowerCase();
};

export const removeCheckedRadio = () => {
    const radios = document.querySelectorAll("input[type=radio]") as NodeListOf<HTMLInputElement>;
    radios.forEach((radio) => {
        radio.checked = false;
    });
};

export const removeChecked = () => {
    const checkboxes = document.querySelectorAll("input[type=checkbox]") as NodeListOf<HTMLInputElement>;
    checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
    });
};


export const isMobileHelper = () => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia && window.matchMedia("(max-width: 570px)").matches;
};

export const isMobile = () => window.matchMedia && window.matchMedia("(max-width: 480px)").matches;

export const isTablet = () => window.matchMedia && window.matchMedia("(max-width: 1024px)").matches;

export const getStartOfWeek = (date)=> {
    const dt = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const offset = dt.getDate() - (dt.getDay() === 0 ? 6: dt.getDay() - 1);
    return new Date(dt.setDate(offset));
}

export const getStartOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1)
}

export const getStartOfYear = (date) => {
    return new Date(date.getFullYear(), 0, 1)
}

export const getLastWeeksDays = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
}

export const formatDate = (date: string | Date) => {
    const dateFormat = new Date(date);
    const options = {year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = dateFormat.toLocaleString("es-ES", options);
    return formattedDate;
}

export const convertArrayToObject = (array: [], key: string) => {
    const obj = {};
    return array.reduce((obj, item) => {
        return {
            ...obj,
            [item[key]]: item,
        }
    }, obj);
};

export const isDateMoreThanThreeMonthsAgo = (dateString: string | undefined) => {
    return isDateMoreThanXMonthsAgo(dateString, 3);
}

export const isDateMoreThanOneYearAgo = (dateString: string | undefined) => {
    return isDateMoreThanXMonthsAgo(dateString, 12);
}

export const isDateMoreThanXMonthsAgo = (dateString: string | undefined, months: number) => {
    if (dateString == undefined) {
        return null;
    }
    const date = new Date(dateString);
    const currentDate = new Date();
    const xMonthsAgo = new Date();
    xMonthsAgo.setMonth(currentDate.getMonth() - months);

    return date < xMonthsAgo;
}

export const  getRandomItems = (originalArray, numItems) => {
    const newArray: any = [];

    const getRandomItem = (array) => array[Math.floor(Math.random() * array.length)];

    for (let i = 0; i < numItems; i++) {
      const randomItem = getRandomItem(originalArray);
      newArray.push(randomItem);
    }

    return newArray;
}
